import React, { useState, useRef, useEffect } from "react";
import BaseModal from "../UI/BaseModal/BaseModal";
import { useSelector } from "react-redux";
import BaseButton from "../UI/BaseButton/BaseButton";
import "./MFAModal.scss";
import { useDispatch } from "react-redux";
import { MFAGoogle, UpdateUserExternalRef } from "../../util/http";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Input from "../UI/Input/Input";
// import handleChange from "../../hooks/handleChange";
import { useNavigate } from "react-router-dom";
import { changeUserDetails } from "../../util/API/admin";
import { Box, Typography } from "@mui/material";
import { setLoggedInUser } from "../../store/redux/login";

function GoogleAuthModal({ open, onClose, setLoggedIn, authenticatorCode, setAuthenticatorCode }) {
  const [qrCode, setQrCode] = useState(null);
  const [secretKey, setSecretKey] = useState(null);
  const [errorText, setErrorText] = useState("");
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  // const [authenticatorCode, setAuthenticatorCode, reset] = handleChange("");
  const [submitLoading, setSubmitLoading] = useState(false);
  let configVariables = useSelector((state) => state.config.baseConfig);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.login.user);
  const userEmail = useSelector((state) => state.login.email);
  const userSecurity = useSelector((state) => state.login.securityAccess);
  const phoneNumber = user ? maskNumber(user.telephoneno) : null;
  const email = user ? maskEmail(user.other1) : null;
  const userId = user?.id;
  const userUsername = userEmail?.emailAccount;
  const hasMFA = user?.mfasecrectkey;
  const hasMFAEnabled = useSelector((state) => state.login.mfaActive);
  const mfaRefId = useSelector((state) => state.login.mfaRefId);
  const firstInputRef = useRef(null); // Reference to the first input

  const logininfo = useSelector((state) => state.login)

  useEffect(() => {
    setAuthenticatorCode("");
    setErrorText("");
  }, []);

  useEffect(() => {
    if (open && firstInputRef.current) {
      firstInputRef.current.focus(); // Focus on the first input when the modal opens
      setAuthenticatorCode("");
    }
  }, [open]);

  let userResponse = sessionStorage.getItem("userResponse");
  const authUser = sessionStorage.getItem("user");
  let securityRoleId = sessionStorage.getItem("userSecurityRoleId");
console.log("userSecurityRoleId===============",securityRoleId);
  useEffect(() => {
    const fetchSecretKey = async () => {
      setLoading(true);

      const response = await MFAGoogle(userId, userUsername, configVariables?.mfaTitle);
      if (response?.payload?.header?.callStatus === "1") {
        setSecretKey(response?.payload?.body?.secret);
        setQrCode(response?.payload?.body?.qrcode);
      } else {
        console.log("Error");
      }
      setLoading(false);
    };

    setErrorText("");
    if (hasMFAEnabled === "0" && user) {
      fetchSecretKey();
    }
  }, [user]);

  function maskNumber(str) {
    if (str.length <= 4) {
      return str;
    }
    return "*".repeat(str.length - 4) + str.slice(-4);
  }

  function maskEmail(email) {
    const atIndex = email.indexOf("@");
    if (atIndex === -1) {
      return email;
    }
    return "*".repeat(atIndex) + email.slice(atIndex);
  }

  const copyText = () => {
    setCopied(true);
    navigator.clipboard.writeText(secretKey);
  };

  const handleSubmit = async () => {
    setSubmitLoading(true);

    if (hasMFAEnabled === "0") {
      const editUser = await UpdateUserExternalRef(
        userId,
        secretKey,
        mfaRefId,
        0
      );
    }

    const response = await MFAGoogle(
      userId,
      userUsername,
      // "PAIY-Portal",
      // "NCS-CRM-Portal",
      configVariables?.mfaTitle,
      authenticatorCode
    );

  if (response?.Status === "1") {
    if (hasMFAEnabled === "0") {
      const updateActive = await UpdateUserExternalRef(
        userId,
        secretKey,
        mfaRefId,
        1
      );
    }

    // === UPDATED ROUTING LOGIC (exact match to Login component) ===
    const roleId = securityRoleId ? String(securityRoleId).trim() : "";
    
    const payrollAdminId = configVariables.payRollAdminId 
      ? String(configVariables.payRollAdminId).trim() 
      : "";
    // let portfolioIds = Array.isArray(configVariables.portfolioAccessIds)
    //   ? configVariables.portfolioAccessIds.map(String)
    //   : String(configVariables.portfolioAccessIds)
    //       .split(',')
    //       .map(id => id.trim());

    // let firstViablePath = 
    //   (roleId === payrollAdminId) ? "payrollbatch" 
    //   : portfolioIds.includes(roleId) ? "portfolio"
    //   : (roleId === "844" || roleId === "707") ? "reporting" 
    //   : (roleId === "845") ? "loans" 
    //   : "crm";

    let payRollIds = String(configVariables.payRollAdminId).split(',').map(id => id.trim());
     let associatepayRollIds = String(configVariables.associatePayrollAdminId)
        .split(',')
        .map(id => id.trim());
    let portfolioIds = Array.isArray(configVariables.portfolioAccessIds)
        ? configVariables.portfolioAccessIds.map(String)
        : String(configVariables.portfolioAccessIds)
            .split(',')
            .map(id => id.trim());

    let roleIds = String(roleId)
        .split(',')
        .map(id => id.trim());

    console.log("roleIds===========", roleIds);
    console.log("payRollIds===========", payRollIds);
    console.log("portfolioIds===========", portfolioIds);

    let firstViablePath = roleIds.some(id => payRollIds.includes(id) || associatepayRollIds.includes(id))
      ? "payrollbatch"
      : roleIds.some(id => portfolioIds.includes(id))
      ? "portfolio"
      : roleIds.some(id => id === '844' || id === '707')
      ? "reporting"
      : roleIds.some(id => id === '845')
      ? "loans"
      : "crm";

      console.log("google_securityRoleId==============",securityRoleId);
      console.log("google_roleId==============",roleId);

      console.log("google_firstViablePath==============",firstViablePath);
      console.log("googleauth_sessionStorage_set_response==============",userResponse);

      sessionStorage.setItem("user", userResponse);
      setLoggedIn(false);
      navigate(`/${firstViablePath}`, { replace: true });

    // After successful MFA:
    const parsedResponse = JSON.parse(userResponse || "{}");
    dispatch(setLoggedInUser(parsedResponse));

      if (hasMFAEnabled === "0") {
        console.log("here has mfa enabled here");
        try {
          const response = await changeUserDetails(userId, "ismfaenable|1");
        } catch (error) {
          console.log(error);
        }
      }

      if (window.zE) {
        window.zE(function () {
          window.zE.show();
        });
      }

      console.log("correct MFA");
    } else {
      setErrorText("Invalid Authenticator Code");
    }
    setSubmitLoading(false);
  };

  const handleInputChange = (e) => {
    setAuthenticatorCode(e.target.value);
  };

  return (
    <BaseModal open={open} handleClose={onClose} width={"250"}>
      <Box className="auth-container">
        <Box className="auth-header text-center">
          {hasMFAEnabled === "0" && (
            <Box className="auth-top-container">
              <Typography variant="h4">Authenticator Login</Typography>
              <Box>
                {loading ? (
                  <Box>Loading...</Box>
                ) : (
                  <img src={qrCode} alt="Authenticator QR Code" loading="lazy" />
                )}
              </Box>
              <Typography>
                Please scan this QR code with your or enter the code below in
                the Authenticator app
              </Typography>
              <Box className="mfa-code-container">
                {loading ? (
                  <Box>Loading...</Box> // Placeholder for loading state
                ) : (
                  <span>{secretKey}</span>
                )}
                <Box onClick={copyText}>
                  <ContentCopyIcon />
                </Box>
              </Box>
              {copied && <span>Copied!</span>}
            </Box>
          )}
          <Box className="mt-3">
            <Input
              label={"Enter authenticator code from your Authenticator app"}
              onChange={handleInputChange}
              // textInput={authenticatorCode}
              value={authenticatorCode}
              ref={firstInputRef}
            />
          </Box>
          <Box className="mt-3 pt-2 d-flex justify-content-end">
            <BaseButton
              buttonText={"Submit"}
              onClick={handleSubmit}
            />
          </Box>
          <Box className="pt-3">
            <span className="text-danger mt-3">{errorText}</span>
          </Box>
        </Box>
      </Box>
    </BaseModal>
  );
}

export default GoogleAuthModal;